import { CheckCircle2, Loader2, Send, XCircle } from "lucide-react";

const BTN = "inline-flex items-center gap-2 px-4 py-2 text-[11px] uppercase tracking-[0.25em]";

export function ExpenseActions({ perms, hasItems, submitting, onCancel, onSubmit, onDecide }) {
  return (
    <div className="mt-6 flex flex-wrap justify-end gap-2">
      {perms.can_cancel && (
        <button data-testid="expense-cancel-btn" onClick={onCancel}
          className={`${BTN} border border-slate-300 hover:bg-slate-50`}>
          Cancelar relatório
        </button>
      )}
      {perms.can_submit && (
        <button
          data-testid="expense-submit-btn"
          onClick={onSubmit}
          disabled={submitting || !hasItems}
          className={`${BTN} bg-[#002776] text-white hover:bg-[#001a5a] disabled:opacity-40`}
        >
          {submitting ? <Loader2 size={14} className="animate-spin" /> : <Send size={14} />} Enviar para aprovação
        </button>
      )}
      {perms.can_approve && (
        <>
          <button data-testid="expense-reject-btn" onClick={() => onDecide("reject")}
            className={`${BTN} border border-rose-400 text-rose-700 hover:bg-rose-50`}>
            <XCircle size={14} /> Rejeitar
          </button>
          <button data-testid="expense-approve-btn" onClick={() => onDecide("approve")}
            className={`${BTN} bg-emerald-700 text-white hover:bg-emerald-800`}>
            <CheckCircle2 size={14} /> Aprovar
          </button>
        </>
      )}
    </div>
  );
}
